module.exports = __webpack_public_path__ + "img/T6-A-rc_7.8740a720.png";